import * as yup from "yup";
const phoneRegex = /^[0-9+\-().\s]*$/;
export const ResourceValidationSchema = yup.object({
    resourceEmail: yup
      .string("Enter your email")
      .email("Enter a valid email")
      .required("Email is required"),
    resourceName: yup
      .string("Enter Resource Name")
      .trim()
      .required("Resource Name is required"),
    resourcePhoneNumber: yup
      .string()
      .nullable()
      .notRequired()
      .test("is-valid-phone", "Invalid phone number", (value) => {
        if (!value) return true;
        return phoneRegex.test(value);
      }),
  });